import React, { PureComponent } from "react";
import { withStyles, Button, CircularProgress } from "@material-ui/core";

class LoadingButton extends PureComponent {
  render() {
    const { loading, children, classes, ...rest } = this.props;

    return (
      <Button
        disabled={loading}
        classes={{
          contained: classes.buttonContained,
        }}
        {...rest}
      >
        {children}
        {loading && (
          <CircularProgress
            size={20}
            color="secondary"
            classes={{
              root: classes.circularProgress,
            }}
          />
        )}
      </Button>
    );
  }
}

const styles = theme => ({
  buttonContained: {
    "&.Mui-disabled": {
      backgroundColor: theme.palette.grey[300], // default button color
    },
  },
  circularProgress: {
    marginLeft: theme.spacing(1),
  },
});

export default withStyles(styles)(LoadingButton);
